import React, { useState } from 'react'
import Image from '../../common/Image'
import Toggle from '../../common/toggle'
// import Radio from '../../common/toggle/Radio'
import './invoice.scss'
import Input from '../../common/Input'
import { BarCode,LoveCode,UnifiedBusinessNo } from '../../../api/invoice'

const Invoice = ({ setInvoiceModal, invoiceData,onSubmit }) => {
    const [error, setError] = useState(null)
    const [data, setData] = useState({
        ...invoiceData,
        self: "message"
    })
    let options = [
        { id: 1, name: "個人發票" },
        { id: 2, name: "發票捐贈" },
        { id: 3, name: "公司發票" },
    ]
    const checkvalid = () => {
        const { type, self, barCode, loveCode, unifiedBusinessNo,companyAddr} = data
        let unvalid = false
        if (type.id === 1) {
            if (self === 'barCode' && !barCode) {
                unvalid = true
            }
        } else if (type.id === 2) {
            unvalid = !loveCode
        } else {
            unvalid = !unifiedBusinessNo || !companyAddr
        }
        return unvalid
    }
    const onChange = async(key, val)=>{
        // setData({ ...data, code: val })
        //手機載具
        let obj={...data}
        
        if(!val){
            delete obj[key]
            setError(null)
        }

        let res 
        if(key==='barCode' && val){
             res = await BarCode({[key]:val})
            // let{result} = res
            // if(result.isExist){
            //     setError(null)
            //     obj[key] = val
            // }else{
            //     setError({
            //         type:key,
            //         message:"查無此手機條碼載具"
            //     })
            // }
        }else if(key === 'loveCode'){
            if(val.length > 2){
               res = await LoveCode({[key]:val})

            }
        }else if(key ==='unifiedBusinessNo'){
            if(val.length === 8){
                res = await UnifiedBusinessNo({[key]:val})
            }else{
                delete obj.companyName
            }

        }
        if(res){
            const {result} = res

            if(result.isExist){
                if(key === 'loveCode'){
                    setError({
                        status:200,
                        type:key,
                        message:result.organName
                    })
                }
                obj[key] = val
                if(key === 'unifiedBusinessNo'){
                    obj.companyName = result.companyName
                }
            }else{

                setError({
                    type:key,
                    message: 
                    key==='barCode' ? "查無此手機條碼載具":
                    key==='loveCode' ? "查無此捐贈單位": "查無此公司統一編號"
                })
            }
        }
        setData(obj)


    }

    return (
        <div className='modal page-modal'>
            <div className='block'>
                <div className='container'>
                    <div className="page-header">
                        <button className="btn-circle" onClick={() => setInvoiceModal(null)}>
                            <Image src="/images/icons/arrow_left.svg" svg />
                        </button>
                        <div className="page_header__title">
                            <h1 className="font-heading">發票設定</h1>
                            <Toggle
                                style={{ marginTop: 16 }}
                                defaultValue={data.type}
                                list={options}
                                onChange={(data) => {
                                    let obj={ type: data }
                                    setError(null)
                                    if(data.id === 1){
                                        obj.self='message'
                                    }
                                    setData(obj)

                                }}
                            />
                        </div>
                    </div>
                    <div className='content-block'>
                        <div className='invoice-block'>
                            {
                                data.type.id === 1 && (
                                    <>
                                        <div className='radio'>
                                            <div className="radio-container"
                                                onClick={() => {
                                                    setData({ ...invoiceData, self: "message" })
                                                }}
                                            >
                                                <input type="radio"
                                                    name="radio-group"
                                                    checked=
                                                    {data.self === 'message'} />
                                                <label for="test1"></label>
                                            </div>
                                            <div className='radio-label'>
                                                <p>發票將以簡訊的方式發送</p>
                                                <p className='text'>可追加輸入電子郵件收取發票通知</p>
                                                {
                                                    data.self === 'message' && (
                                                        <Input
                                                            defaultValue={data.email}
                                                            placeholder="請輸入電子郵件信箱（非必填）"
                                                            onChange={(val) => {
                                                                setData({ ...data, email: val })
                                                            }}
                                                        />
                                                    )
                                                }

                                            </div>
                                        </div>
                                        <div className='radio'>
                                            <div className="radio-container"
                                                onClick={() => {
                                                    setData({ ...invoiceData, self: "barCode" })
                                                }}
                                            >
                                                <input type="radio" name="radio-group"
                                                    checked={data.self === 'barCode'}
                                                />
                                                <label for="test1"></label>
                                            </div>
                                            <div className='radio-label'>
                                                <p>手機條碼載具</p>
                                                {
                                                    data.self === 'barCode' && (
                                                        <Input
                                                            defaultValue={data.barCode}
                                                            placeholder="例）/1234CBA"
                                                            rules={
                                                                [{ pattern: new RegExp(/^\/[0-9A-Z.+-]{7}$/), message: '請輸入/開頭固定長度為8碼的載具號碼' }]
                                                            }
                                                            error={error} 
                                                            errorText={error?.message}
                                                            onChange={(val) => {
                                                                onChange("barCode",val)
                                                            }}
                                                        />
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </>)
                            }
                            {
                                data.type.id === 2 && (<>
                                    <Input
                                        defaultValue={data.loveCode}
                                        placeholder="請輸入捐贈碼"
                                        error={error && error.status !==200}
                                        errorText={error?.message}
                                        onChange={(val) => {
                                            onChange("loveCode",val)
                                            // 查無此捐贈單位
                                            // setError('查無此捐贈單位')
                                            // setData({ ...data, loveCode: val })
                                        }}
                                    />
                                </>)
                            }
                            {
                                data.type.id === 3 && (<>
                                    <Input
                                        defaultValue={data.unifiedBusinessNo}
                                        placeholder="請輸入公司統一編號"
                                        error={error}
                                        errorText={error?.message}
                                        onChange={(val) => {
                                            // 查無此捐贈單位
                                            // setError('查無此捐贈單位')
                                            onChange("unifiedBusinessNo",val)
                                        }}
                                    />
                                    {
                                        data.unifiedBusinessNo &&(<>
                                            <Input
                                                defaultValue={data.companyName}
                                                placeholder="請輸入公司名稱"
                                                onChange={(val) => {
                                                    setData({ ...data, companyName: val })
                                                }}
                                            />
                                            <Input
                                                // defaultValue={data.unifiedBusinessNo}
                                                placeholder="請輸入發票地址"
                                                onChange={(val) => {
                                                    setData({ ...data, companyAddr: val })
                                                }}
                                            />
                                        </>)
                                    }
                                </>)
                            }
                        </div>
                        <button className='btn'
                            disabled={checkvalid()}
                            onClick={()=>{
                                onSubmit(data)
                            }}
                        >

                            套用
                        </button>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default Invoice